import { render, staticRenderFns } from "./GoodsBindModal.vue?vue&type=template&id=17ecf387&scoped=true"
import script from "./GoodsBindModal.vue?vue&type=script&lang=js"
export * from "./GoodsBindModal.vue?vue&type=script&lang=js"
import style0 from "./GoodsBindModal.vue?vue&type=style&index=0&id=17ecf387&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecf387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ecf387')) {
      api.createRecord('17ecf387', component.options)
    } else {
      api.reload('17ecf387', component.options)
    }
    module.hot.accept("./GoodsBindModal.vue?vue&type=template&id=17ecf387&scoped=true", function () {
      api.rerender('17ecf387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/goods/GoodsBindModal.vue"
export default component.exports